// extracted by mini-css-extract-plugin
module.exports = {"modalOuter":"_3Wqw1","questionHeading":"_1h-HA","subHeadingAnswer":"_1dNGu"};